import { useState } from "react";
import { useIsomorphicLayoutEffect } from "usehooks-ts";

export default function useBodyWidth() {
  const [bodyWidth, setBodyWidth] = useState(0);

  const handleSize = () => {
    setBodyWidth(document.body.clientWidth);
  };

  useIsomorphicLayoutEffect(() => {
    handleSize();
    var ro = new ResizeObserver(() => {
      handleSize();
    });
    ro.observe(document.body);
    return () => {
      ro.disconnect();
    };
  }, []);

  return bodyWidth;
}
